import {VEHICLESLIST_TYPE} from '../actions/types';

const INITIAL_STATE = {
  Bikes: [],
  Bicycles: [],
  Scooter: [],
  Both: [],
  parking: [],
  type: 'both',
  liveActiveVehicle: null,
  reload: false,
  vehicleIsLoading: true,
  stationIsLoading: true,
};

const VehiclesList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VEHICLESLIST_TYPE:
      return {
        ...state,
        ...action.payload,
        reload: !state.reload,
      };
    default:
      return state;
  }
};

export default VehiclesList;
